/*
 * cart-timer.js — compte à rebours de réservation du panier.
 *
 * L'échéance est stockée dans le navigateur : le décompte survit aux
 * re-rendus du tiroir et aux changements de page. Il repart à zéro quand le
 * panier est vidé.
 */
(function () {
  'use strict';

  // Le tiroir est rendu sur toutes les pages : une seule initialisation.
  if (window.__cartTimerReady) return;
  window.__cartTimerReady = true;

  var KEY = 'helvia_cart_timer_deadline';

  function readDeadline() {
    try {
      return parseInt(localStorage.getItem(KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function writeDeadline(value) {
    try {
      if (value) localStorage.setItem(KEY, String(value));
      else localStorage.removeItem(KEY);
    } catch (e) {
      /* navigation privée */
    }
  }

  function tick() {
    // Le tiroir est re-rendu à chaque modification du panier : on relit
    // l'élément à chaque passage plutôt que de le garder en mémoire.
    var wrap = document.querySelector('[data-cart-timer]');

    // Pas de bandeau = panier vide : la prochaine mise au panier repart d'une
    // durée complète.
    if (!wrap) {
      writeDeadline(0);
      return;
    }

    var minutes = parseInt(wrap.dataset.minutes, 10) || 15;
    var now = Date.now();
    var deadline = readDeadline();

    // Échéance absente, ou incohérente (durée réduite dans le thème) :
    // on repart d'une durée complète.
    if (!deadline || deadline - now > minutes * 60000) {
      deadline = now + minutes * 60000;
      writeDeadline(deadline);
    }

    var left = deadline - now;
    if (left <= 0) {
      wrap.hidden = true;
      return;
    }

    wrap.hidden = false;
    var total = Math.floor(left / 1000);
    var m = Math.floor(total / 60);
    var s = total % 60;
    var out = wrap.querySelector('[data-cart-timer-value]');
    if (out) out.textContent = m + ':' + (s < 10 ? '0' + s : s);
  }

  tick();
  setInterval(tick, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  }
})();
